export const PAYPAL_CLIENT_ID = {
    clientId: 'AU5erX4RwaEaHC8e79QKyX7WrOmxxclYwUa-9MPuwgiWtdj0r9a8TapgZb4xwIuCBsob7ObxxIiEOEAr' // live
    //clientId: 'ARZw4L4xoa9bRhMNvPosITftTY7X7Kx0e7WdqE7bb3Ke9PQj8GjXsxSqHvcGSN0fvtN6omX_ZaiCKVGi'   // test
}

export const CURRENCY_CODE = 'EUR'
export const ACOMPTE = 'Acomptes' 

